import * as React from 'react';
import { connect } from 'react-redux'
import { IApplicationState } from '../../store/ApplicationState';
import { IState as IStatePosts } from '../../common/store/posts/state';
import { actionCreator, IActions } from '../../common/store/posts/actions/creators';
import { IState as ITagState } from '../tags/store/state';
import { IActions as ITagsActions, actionCreator as tagsActions } from '../tags/store/actions/creators';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { Grid, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, FormControlLabel, Checkbox, StyledComponentProps } from '@material-ui/core';
import { TagSelector } from './components/tagSelector';
import { RichTextEditor } from '../../ui-components/richTextEditor/RichTextEditor';
import Preview from './components/Preview';
import { tag } from '../../model/tag';
import Cropper from './components/Cropper'
import { stateToHTML } from "draft-js-export-html";
import { getEditorOptions, getFullHtml } from './components/blockStyleParser';
import Button from '../../ui-components/Button/Button';
import TextField from '../../ui-components/TextField/TextField';
import { withStyles } from '@material-ui/core';
import { styles } from './styles';

interface IProps extends IActions, ITagsActions, ITagState, IStatePosts, StyledComponentProps {
    match: {
        params: {
            id: string
        },
        path: string
    }
}

interface IInternalState {
    editorState: EditorState;
    editorId: string;
    open: boolean;
}

class CompContainer extends React.Component<Partial<IProps>, IInternalState>
{
    constructor(p, c) {
        super(p, c);

        this.state = {
            editorState: EditorState.createEmpty(),
            editorId: undefined,
            open: false,
        }
    }

    static getDerivedStateFromProps(props: IProps, state: IInternalState) {
        const { post } = props;
        // console.log("getDerivedStateFromProps:", "ID:", post._id)
        // console.log("getDerivedStateFromProps:", "EDITOR:", state.editorId)
        // console.log("getDerivedStateFromProps:", "POST:", (post !== undefined));
        // console.log("getDerivedStateFromProps:", "URL:", props.match.path);
        // console.log("getDerivedStateFromProps:", "URL:", '/private/edit/' + post?._id);
        if (props.match.path === '/private/new' && !state.editorId) {
            // console.log("getDerivedStateFromProps:", "NEW")
            const editorNewState = EditorState.createEmpty();
            // const raw = JSON.stringify(convertToRaw(editorNewState.getCurrentContent()));
            props.newPost();
            return {
                ...state,
                editorState: editorNewState,
                editorId: 'EDIT'
            }
        }
        else if (post && state.editorId === 'EDIT' && post._id) {
            if (props.match.path === '/private/new') {
                props.navigateTo(`/private/edit/${post._id}`)
            }
            // console.log("getDerivedStateFromProps:", "EDIT", post)
            // console.info('getDerivedStateFromProps', 'state derived from changed props');
            // if (post._id !== '' && post.rawdata !== '') {
            let editorStateNew = EditorState.createWithContent(convertFromRaw(JSON.parse(post.rawdata)));
            return {
                ...state,
                editorState: editorStateNew,
                editorId: post._id
            }
            //     // } else {
            //     //     return {
            //     //         ...state,
            //     //         editorState: EditorState.createEmpty(),
            //     //         editorId: post._id
            //     //     }
            // }
        }
        else if (post && !state.editorId && props.match.path === '/private/edit/:id' && post._id !== '') {
            // console.log("getDerivedStateFromProps:", "RAWDATA", post)
            let editorStateNew = EditorState.createWithContent(convertFromRaw(JSON.parse(post.rawdata)));
            return {
                ...state,
                editorState: editorStateNew,
                editorId: post._id
            }
        } else {
            // console.log("getDerivedStateFromProps:", "ELSE")
            return state;
        }
    }
    componentDidUpdate(precProps, precState) {
        //controllo nel caso in cui il componente non venga smontato, ma l'utente passi da edit a new
        if (precProps.post._id !== this.props.post._id && this.props.post._id === '') {
            this.props.clearFields();
        }
    }
    componentDidMount() {
        if (!this.props.tags || this.props.tags.length === 0) {
            this.props && this.props.loadTags && this.props.loadTags();
        }
        var id = this.props.match.params.id;
        if (id !== undefined && id !== '') {
            this.props.getPost(id);
        } else {
            this.props.clearFields();
        }
    }
    private handleSave = () => {
        this.setState({
            open: false
        });
        const options: any = getEditorOptions();
        let rawHtml = stateToHTML(this.state.editorState.getCurrentContent(), options);
        rawHtml = getFullHtml(rawHtml);

        this.props.post.htmlContent = rawHtml;
        this.props.savePost(this.props.post);
        // this.setState({
        //     editorId: 'EDIT'
        // });
    }
    private handleChange = (editorStateNew: EditorState) => {
        this.setState({
            editorState: editorStateNew
        });
        const { post, changeRTE } = this.props;
        const raw = JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent()));
        changeRTE(post, raw);
    }
    // private handleChangeDescription = (newValue: string) => {
    //     const { post } = this.props;
    //     this.props && this.props.changeDescription && this.props.changeDescription(post, newValue);
    // }
    private handleChangeSurveyText = (newValue: string) => {
        const { post } = this.props;
        this.props && this.props.changeSurveyText && this.props.changeSurveyText(post, newValue);
    }
    private handleChangeTitle = (newValue: string) => {
        const { post } = this.props;
        this.props && this.props.changeTitle && this.props.changeTitle(post, newValue);
    }
    private handleClickOnTag = (tag: tag) => {
        const { post } = this.props;
        this.props && this.props.changeAssociatedTag && this.props.changeAssociatedTag(post, tag);
    }
    private handleChangeQuestion = (newValue: boolean) => {
        const { post } = this.props;
        this.props && this.props.changeYesNoQuestion && this.props.changeYesNoQuestion(post, newValue);
    }
    private handleClickOpen = () => {
        this.setState({
            open: true
        });
    }
    private handleClose = () => {
        this.setState({
            open: false
        });
    }
    private handleClickClear = () => {
        this.props.clearFields();
        // this.props.goBack();
    }

    render() {
        return (
            <>
                <Grid container>
                    <Grid item sm={2}>
                        <TagSelector handleClickOnTag={this.handleClickOnTag} tags={this.props.tags} post={this.props.post} />
                    </Grid>
                    <Grid item sm={6}>
                        <RichTextEditor
                            placeHolderText=""
                            readOnly={false}
                            onChange={this.handleChange}
                            id={this.state.editorId}
                            initialState={this.state.editorState} />
                    </Grid>
                    <Grid item sm={4}>
                        <Preview
                            EditorState={this.state.editorState}
                            imgBase64={this.props.post.imagebase64}
                            title={this.props.post.title}
                            surveyText={this.props.post.surveyText}
                            yesNo={this.props.post.hasYesNoQuestion} />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item sm={8}>
                        <TextField
                            label="Titolo"
                            onChange={this.handleChangeTitle}
                            value={this.props.post.title}
                        />
                    </Grid>
                    <Grid item sm={4}>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item sm={8}>
                        <Cropper changeImageBase64={(p, v) => { this.props.changeImageBase64(p, v) }} post={this.props.post} classes={this.props.classes} />
                    </Grid>
                    <Grid item sm={4}>
                    </Grid>
                    {/* <Grid item sm={8}>
                        <TextField
                            label="Testo sondaggio"
                            onChange={this.handleChangeDescription}
                            value={this.props.post.description}
                        />
                    </Grid> */}
                </Grid>
                <Grid container>
                    <Grid item sm={8}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.props.post.hasYesNoQuestion}
                                    onChange={(e) => this.handleChangeQuestion(e.target.checked)}
                                    value="hasYesNoQuestion"
                                    color="primary"
                                />
                            }
                            label="Il post prevede una domanda con possibile risposta Si/No"
                        />
                    </Grid>
                    {this.props.post.hasYesNoQuestion && <Grid item sm={8}>
                        <TextField
                            label="Testo domanda"
                            onChange={this.handleChangeSurveyText}
                            value={this.props.post.surveyText}
                        />
                    </Grid>}
                </Grid>
                <Grid container>
                    <Grid item sm={12}>
                        <Button onClick={this.handleClickClear} className={this.props.classes.buttons}>Annulla</Button>
                        <Button onClick={this.handleClickOpen} className={this.props.classes.buttons}>Salva</Button>
                        <Dialog
                            open={this.state.open}
                            onClose={(e) => this.handleClose()}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">Inserimento Post</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">Confermare la registrazione dei dati?</DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleClose}>No</Button>
                                <Button onClick={this.handleSave}>Si</Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>
                </Grid>
            </>
        )
    }
}
const mapStateToProps = (state: IApplicationState, ownProps: any): any => {
    return {
        ...ownProps,
        ...state.tags,
        ...state.posts
    }
}
const mapDispatchToProps = (dispatch: any): any => {
    return {
        ...actionCreator(dispatch),
        ...tagsActions(dispatch)
    }
};
export const PostEditContainer = withStyles(styles)(connect(
    mapStateToProps,
    mapDispatchToProps
)(CompContainer as any));